import { DateTime } from 'luxon';
import cloneDateTime from './cloneDateTime';
import isSameMonth from './isSameMonth';

export default function isPrevMonth(a, b) {
  if (!(a instanceof DateTime) || !(b instanceof DateTime)) return false;
  
  
  return isSameMonth(cloneDateTime(a).minus({ months: 1 }), b);
}
